<template>
  <div class="page_container">
    <div v-if='$env.isWeChat && $env.isAndroid && !headerHidden'>
      <div class="top_header">
        <div class="logo"></div>
        <div class="logo_title" v-text="appName"></div>
        <a id="open_app" href="javascript:void(0)"></a>
      </div>
      <wx-open-launch-app id="launch-btn" appid="wx5e38a906515ab326" :extinfo="extinfoData" ref="wxLaunchComponent">
        <script type="text/wxtag-template">
        <button class="download btn" style="height:50px;width:100%;border:none;">APP唤起</button>
      </script>
      </wx-open-launch-app>
    </div>

    <div class="top_header" v-else-if="!headerHidden">
      <div class="logo"></div>
      <div class="logo_title" v-text="appName"></div>
      <div id="open_app"></div>
    </div>





    <div :class="{ 'main_content': true, 'allHeight': headerHidden }">
      <router-view />
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from "vuex";
import { getRandomStr32, initOpenApplicationFun, getCookie, setCookie } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Layout",
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      extinfoData: {},
    };
  },
  watch: {
    '$route'(to, from) {
      if (to.path == from.path) {
        location.reload();
      }
    },
    "shouldTriggerOpenApp": function (newVal) {
      if (newVal) {
        alert('监听到了')
        if (this.$env.isWeChat && this.$env.isAndroid && !this.headerHidden) {
          //微信环境js点击wx-open-launch-app不了
        } else {
          const openAppBtn = document.querySelector("#open_app");
          if (openAppBtn) {
            openAppBtn.click();
          }
        }
        // 重置状态
        this.triggerOpenApp(false);
      }
    }
  },
  computed: {
    ...mapState("app", ["deviceId", "appName","shouldTriggerOpenApp"]),
  },
  methods: {
    ...mapActions("app", ["setDeviceId",'triggerOpenApp']),
    async getExternalIp() {
      let response
      try {
        response = await fetch('//api.ipify.org?format=json');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      } catch (error) {
        response = await fetch('//api64.ipify.org/?format=json');
        if (!response.ok) {
          throw new Error('Network response for response1 was not ok');
        }
      }

      if (!response.ok) {
        console.log(`获取ip报错`);
      }
      const data = await response.json();
      return data.ip;
    },
  },
  async mounted() {
    let query = this.$route.query;
    this.headerHidden = !!query.client || this.$env.isApp;

    if (this.$env.isWeChat && this.$env.isAndroid && !this.headerHidden) {
      this.extinfoData = JSON.stringify(query)
    } else {
      // 友盟打开app
      initOpenApplicationFun('open_app', query)
    }

    var deviceId = ''
    if (!this.deviceId) {
      deviceId = getRandomStr32();
      this.setDeviceId(deviceId);
    }

    if (!this.headerHidden) {
      const ip = await this.getExternalIp()

      const cookieName = "collection_cookie_id";
      let cookie_id = getCookie(cookieName);
      if (!cookie_id) {
        cookie_id = this.deviceId || deviceId
        setCookie(cookieName, cookie_id, 365);
        console.log('设置cookie_id有效期为一年', cookie_id)
      }

      const ua = navigator.userAgent;
      let params = {
        cookie_id,
        ip,
        ua
      }
      commApi.saveH5Data(JSON.stringify(params))
    }
  },
};
</script>
<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: 100%;

  #launch-btn {
    width: 100%;
    height: 12.4vw;
    position: absolute;
    z-index: 10000;
    opacity: 0;
  }

  .top_header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 12.4vw;
    background-color: #fff;
    outline: 1px solid #f0f0f0;

    .logo {
      float: left;
      width: 8.4vw;
      height: 8.4vw;
      background-image: url(~@/assets/images/logo/logo2.jpg);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      margin-left: 3.6vw;
      margin-top: 2vw;
    }

    .logo_title {
      float: left;
      height: 5vw;
      line-height: 5vw;
      margin-left: 1.8vw;
      margin-top: 3.7vw;
      font-size: 4vw;
    }

    #open_app {
      float: right;
      width: 15vw;
      height: 6.2vw;
      margin-right: 3vw;
      margin-top: 3.1vw;
      background-image: url(~@/assets/images/btn_open.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  .main_content {
    position: relative;
    left: 0;
    top: 12.4vw;
    width: 100%;
    height: calc(100% - 12.4vw);
  }

  .allHeight {
    height: calc(100%);
    top: 0;
  }
}

@media screen and (min-width: 750px) {
  .page_container {
    .top_header {
      height: 93px;

      .logo {
        width: 63px;
        height: 63px;
        margin-left: 27px;
        margin-top: 15px;
      }

      .logo_title {
        height: 37.5px;
        line-height: 37.5px;
        margin-left: 13.5px;
        margin-top: 27.75px;
        font-size: 28px;
      }

      #open_app {
        width: 112.5px;
        height: 46.5px;
        margin-right: 22.5px;
        margin-top: 23.25px;
      }
    }

    .main_content {
      top: 93px;
      height: calc(100% - 93px);
    }
  }
}
</style>